import { render, staticRenderFns } from "./CreateCourseModal.vue?vue&type=template&id=43463c11&scoped=true&"
import script from "./CreateCourseModal.vue?vue&type=script&lang=js&"
export * from "./CreateCourseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43463c11",
  null
  
)

export default component.exports